import React from 'react';

// Components
import StripeContainer from '../../Stripe/StripeContainer';
import PaymentMethodSection from './PaymentMethodSection';

export default function PaymentMethodSectionContainer(props) {
  return (
    <StripeContainer>
      <PaymentMethodSection {...props} />
    </StripeContainer>
  );
}
